import { __rest, __assign } from '../../_virtual/_tslib.js';
import React from 'react';
import BaseInput from './BaseInput.js';
import Label from './Label.js';
import { StyledIconDiv, CountWrapper } from './style.js';
import { ResetIconButton, CheckIcon } from './Icons.js';

function TimeDisplay(_a) {
    var seconds = _a.seconds, showTime = _a.showTime;
    var minutes = Math.floor(seconds / 60);
    var secondsLessThan60 = seconds % 60;
    if (!showTime) {
        return null;
    }
    if (seconds <= 0) {
        return React.createElement(CountWrapper, null, "0:00");
    }
    return (React.createElement(CountWrapper, null, minutes + ":" + (secondsLessThan60 < 10 ? "0" + secondsLessThan60 : secondsLessThan60)));
}
function Count(_a) {
    var label = _a.label, readOnly = _a.readOnly, disabled = _a.disabled, value = _a.value, validState = _a.validState, seconds = _a.seconds, onResetIconClick = _a.onResetIconClick, isFocused = _a.isFocused, props = __rest(_a, ["label", "readOnly", "disabled", "value", "validState", "seconds", "onResetIconClick", "isFocused"]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Label, __assign({}, props, { label: label, validState: validState, readOnly: readOnly, disabled: disabled, inputValue: value, isFocused: isFocused })),
        React.createElement(BaseInput, __assign({ value: value, labelOfInput: label, validState: validState, isFocused: isFocused, disabled: disabled }, props)),
        value &&
            !disabled &&
            !readOnly &&
            (isFocused || validState === 'error') && (React.createElement(ResetIconButton, { right: validState === 'success' ? '4.8' : '5.4', onClick: onResetIconClick })),
        value && validState === 'success' && (React.createElement(StyledIconDiv, { right: "1.6" },
            React.createElement(CheckIcon, null))),
        React.createElement(TimeDisplay, { showTime: Boolean(validState !== 'success' &&
                !readOnly &&
                !disabled &&
                (value || seconds)), seconds: seconds })));
}

export { Count as default };
